<template>
  <div>
    <hr class="mt-0" />
    <div>
      <div class="display-4 font-3xl mb-3">
        <b-row class="pr-3">
          <b-col>{{ process.process.name }}</b-col>
        </b-row>
      </div>
      <b-tabs
        v-if="
          process.process.schedulable_tasks &&
          process.process.schedulable_tasks.length
        "
        class="mb-3"
      >
        <template
          v-for="(collection, index) in process.process.schedulable_tasks"
        >
          <template v-if="!collection.parent_id">
              <instrument-selector
                :key="index"
                :collection="collection"
                :process="process.process"
              />
          </template>
        </template>
      </b-tabs>
    </div>
  </div>
</template>

<script>
import InstrumentSelector from "./InstrumentSelector";
import InstrumentInstanceCollection from "@/collections/lab/InstrumentInstanceCollection";
import ScheduleSelectButton from "./ScheduleSelectButton";

export default {
  name: "InstrumentList",
  components: {
    InstrumentSelector,
    ScheduleSelectButton,
  },
  props: {
    process: {
      type: Object,
      default: () => null,
    },
  },
  computed: {
  },
  data() {
    return {
      instrument_collection: new InstrumentInstanceCollection(),
    };
  },
  methods: {
  },
};
</script>
